<template>
  <b-modal
    id="column-filter-list-modal"
    v-model="active"
    size="reference"
    centered
    hide-footer
    hide-header
    @close="close"
  >
    <svg-icon name="times-bold" :size="8" class="modal-dialog__close" @click="close"></svg-icon>

    <div class="m-column-filters">
      <div class="m-column-filters__wrapper">
        <div class="m-column-filters__item">
          <c-input
            v-model="condition"
            class="m-column-filters__condition"
            type="select"
            size="small"
            :items="conditions"
          />
        </div>
        <div class="m-column-filters__item m-column-filters__item_value">
          <c-input
            v-model="value"
            class="m-column-filters__value m-column-filters__value_select"
            type="select"
            size="small"
            :items="list"
            :multiple="true"
            :searchable="true"
            placeholder="Выберите значение"
          />
        </div>
        <div class="m-column-filters__actions">
          <c-button
            class="m-column-filters__action"
            :tooltip="'Применить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'check', color: 'success' }"
            @click="apply"
          />
          <c-button
            class="m-column-filters__action"
            :tooltip="'Отменить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'close', color: 'secondary' }"
            @click="reset"
          />
          <c-button class="m-column-filters__action_mobile" color="white" label="Сбросить" @click="reset" />
          <c-button class="m-column-filters__action_mobile" color="primary" label="Применить" @click="apply" />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";
import SvgIcon from "@/components/svg-icon";

const conditions = [
  { label: "Выбрать значения", value: "1" },
  { label: "Все, кроме", value: "2" },
];

export default {
  name: "reference-filter",
  components: {
    "c-button": Button,
    "c-input": Input,
    SvgIcon,
  },

  data() {
    return {
      active: false,
      submitted: false,

      conditions,
      condition: conditions[0],
      value: [],
      list: [],
    };
  },

  mounted() {
    window.addEventListener("keyup", (event) => {
      if (this.active && event.keyCode === 13) {
        this.apply();
      }
    });
  },

  methods: {
    getParams() {
      const { value } = this;
      if (!value.length) {
        return null;
      }
      return {
        values: this.value.map((v) => v.value),
        searchType: this.condition.value,
      };
    },

    async open(params, getList) {
      this.resetValue();

      const list = await getList();
      
      this.list = list;

      if (params) {
        const { values } = params;
        this.value = values
          .map((value) => list.find((item) => item.value.toString() === value.toString()))
          .filter(Boolean);
      }

      if (params) {
        const { searchType } = params;
        const condition = this.conditions.find((c) => c.value === searchType);
        this.condition = condition || conditions[0];
      }

      this.active = true;
    },

    close() {
      this.active = false;
      this.submitted = false;
      this.$emit("close");
    },

    resetValue() {
      this.value = [];
      const [firstCondition] = conditions;
      this.condition = firstCondition;
      this.list = [];
    },

    reset() {
      this.$emit("apply", null);
      this.close();
    },

    apply() {
      this.submitted = true;

      this.$emit("apply", this.getParams());
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-column-filters__wrapper {
  align-items: flex-end;

  @include onlyMobile {
    align-items: stretch;
  }
}
</style>
